import { CommonAPIService } from "src/servicehandlers/CommonHandler";

const baseURL = "/api/classroom/"
export class googleClassroomAPIService {
constructor () {
    this.CommonAPIService = new CommonAPIService();
}

authCallback(router, selected) {
    const url = `${baseURL}authCallback`
    return this.CommonAPIService.getCall(url, selected, router)
}

authCallbackCode(router, code) {
    const url = `${baseURL}authCallback?${code}`
    return this.CommonAPIService.getCall(url, "", router)
}

getClassroomInfo(router) {
    const url = `${baseURL}getClassInfo`
    return this.CommonAPIService.getCall(url, "", router)
}

createClassroomInfo(params, router) {
    const url = `${baseURL}createGoogleClassroom`
    return this.CommonAPIService.postCall(url, params, router)
}

getAllCourses(router, token) {
    const url = `${baseURL}listCourses?token=${token}`
    return this.CommonAPIService.getCall(url, "", router)
}

getCourseByID(courseID, router) {
    const url = `${baseURL}getCourse/${courseID}`
    return this.CommonAPIService.getCall(url, "", router)
}

deleteCourse(courseId, router) {
    const url = `${baseURL}deleteCourse/${courseId}`
    return this.CommonAPIService.deleteCall(url, "", router)
}

createStudent(courseId, router) {
    const url = `${baseURL}createStudent/${courseId}`
    return this.CommonAPIService.postCall(url, "", router)
}

updateStudent(courseId, studentId, router) {
    const url = `${baseURL}updateStudent/${courseId}/${studentId}`
    return this.CommonAPIService.putCall(url, "", router)
}

getStudentsInCourse(courseId, router) {
    const url = `${baseURL}getStudentsInCourse/${courseId}`
    return this.CommonAPIService.getCall(url, "", router)
}

getStudentGrade(courseId, studentId, router) {
    const url = `${baseURL}getStudentGrade/${courseId}/${studentId}`
    return this.CommonAPIService.getCall(url, "", router)
}

getStudentAssignments(courseId, studentId, router) {
    const url = `${baseURL}getStudentAssignments/${courseId}/${studentId}`
    return this.CommonAPIService.getCall(url, "", router)
}

getCourseWork(courseId, router) {
    const url = `${baseURL}getCourseWork/${courseId}`
    return this.CommonAPIService.getCall(url, "", router)
}

getCourseInvitations(courseId, router) {
    const url = `${baseURL}getCourseInvitations/${courseId}`
    return this.CommonAPIService.getCall(url, "", router)
}

getDetailedCourseInfo(router, courseID, token) {
    const url = `${baseURL}getDetailedCourseInfo/${courseID}`;
    const body = {
        token
    };
    return this.CommonAPIService.postCall(url, body, router);
}

}

export default googleClassroomAPIService